import { get, isArray, isEmpty } from 'lodash';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import useT from '../../utils/Translations/useT';
import useCommonTreeSelectorContext from '../CommonTreeSelector/CommonTreeSelectorContext';
import TreeModalSelector from '../NextTree/TreeModalSelector';
import TreeSelectorTooltip from '../NextTree/TreeSelectorTooltip/TreeSelectorTooltip';
import ButtonSelector from './ButtonSelector';
const TWO_ELEMENTS = 2;
export default function TreeSelector({ models, onChange, title, disabled = false, children, applyLabel, emptyValueTitle = '', isRenderOnlySelected = false, adapter = {}, isSingleSelector = false, selection = [], selectionFilter, searchField, isAllSelected: customIsAllSelected, hasClearButton, hasMarginLeft, dataCy, }) {
    const t = useT();
    const { mainTreeModels } = useCommonTreeSelectorContext();
    const filteredModels = useMemo(() => (selectionFilter ? selectionFilter(mainTreeModels) : models), [mainTreeModels, models, selectionFilter]);
    const [modalOpen, setModalOpen] = useState(false);
    const [isAllSelected, setIsAllSelected] = useState(isArray(selection) &&
        !!(selection === null || selection === void 0 ? void 0 : selection.length) &&
        !!filteredModels.length &&
        selection.length === filteredModels.length);
    useEffect(() => {
        setIsAllSelected(isArray(selection) &&
            !isEmpty(selection) &&
            selection.length === (filteredModels === null || filteredModels === void 0 ? void 0 : filteredModels.length));
    }, [setIsAllSelected, selection, filteredModels]);
    const handleOpenModal = useCallback(() => setModalOpen(true), []);
    const handleChange = useCallback((selection, isCancel) => {
        if (isCancel) {
            setModalOpen(false);
            return;
        }
        if (Array.isArray(selection)) {
            onChange(selection);
        }
        else if (isSingleSelector && selection !== null) {
            onChange(selection);
        }
        else {
            setIsAllSelected(false);
        }
        setModalOpen(false);
    }, [isSingleSelector, onChange]);
    const valueTitle = useMemo(() => {
        if (!selection || (Array.isArray(selection) && !selection.length)) {
            return null;
        }
        let title;
        const { resolveNodeTitle } = adapter;
        if (customIsAllSelected || (Array.isArray(selection) && isAllSelected)) {
            title = [t('All')];
        }
        else if (Array.isArray(selection) && selection) {
            title = [
                resolveNodeTitle
                    ? resolveNodeTitle(selection[0])
                    : get(selection, '[0].name'),
            ];
            if (selection.length > 1) {
                title.push(resolveNodeTitle
                    ? resolveNodeTitle(selection[1])
                    : get(selection, '[1].name'));
            }
            if (selection.length > TWO_ELEMENTS) {
                title.push('...');
            }
        }
        else {
            title = [
                resolveNodeTitle ? resolveNodeTitle(selection) : get(selection, 'name'),
            ];
        }
        return (<>
        <span>{title.join(', ')}</span>
        <TreeSelectorTooltip adapter={adapter} isRenderOnlySelected={isRenderOnlySelected} models={models} selection={selection}/>
      </>);
    }, [
        adapter,
        isAllSelected,
        isRenderOnlySelected,
        models,
        selection,
        t,
        customIsAllSelected,
    ]);
    return (<>
      <ButtonSelector className="h-100-p" dataCy={dataCy} disabled={disabled} emptyValueTitle={emptyValueTitle} hasMarginLeft={hasMarginLeft} isAllSelected={isAllSelected} title={title} valueTitle={valueTitle} onClick={handleOpenModal}/>
      {modalOpen && (<TreeModalSelector applyLabel={applyLabel || t('Apply')} hasClearButton={hasClearButton} label={title} modalOpen={modalOpen} models={models} searchField={searchField} selection={selection} onChange={handleChange}>
          {children}
        </TreeModalSelector>)}
    </>);
}
